<template>
  <div class="card border-0">
    <div class="sectionclsbodymain tsk_body_right_back">
      <div class="serach_controls_main tsk_controls_main_cls">
        <div class="serach_controls_main_row1x">
          <div class="tsk_top_filter_right">
            <div class="serach_controls me-2">
              <div class="date-range-picker event-filter-options">
                <date-picker
                  v-model:value="value1"
                  type="date"
                  range
                  format="DD-MM-YYYY"
                  @change="onDateChange"
                  placeholder="Select date range"
                  :disabled-date="disableFutureDates"
                ></date-picker>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body p-0 hghtdashboardclass">
      <div class="right-bodypart pageTblHeightCls overflow-auto w-100">
        <div class="Setcard_row dashboardboxset">
          <div class="dashboardboxset_left ratingLeftMianCls">
            <div class="boxcommon rr-card">
              <div class="rr-title">Ratings (All Time Rating)</div>
              <div class="rr-container">
                <!-- LEFT SIDE -->
                <div class="rr-left">
                  <div class="rr-score">
                    <span class="rr-score-number">{{ $store.state.allTimeRating }}</span>
                    <span class="rr-score-star">★</span>
                  </div>
                  <div class="rr-meta">{{ $store.state.totalRatingsDisplay }}</div>
                </div>

                <!-- RIGHT SIDE -->
                <div class="rr-right">
                  <div
                    v-for="row in $store.state.totalRatingRows"
                    :key="row.stars"
                    class="rr-row"
                  >
                    <span class="rr-row-star">{{ row.stars }} ★</span>
                    <div class="rr-bar">
                      <div class="rr-bar-bg">
                        <div
                          class="rr-bar-fill"
                          :style="{ width: row.percent + '%' }"
                          :class="'stars-' + row.stars"
                        ></div>
                      </div>
                    </div>
                    <span class="rr-row-count">{{ row.count }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="dashboardboxset_right ratingLeftMianCls">
            <div class="boxcommon rr-card">
              <div class="rr-title">Ratings (Selected Time Rating)</div>
              <div class="rr-container">
                <!-- LEFT SIDE -->
                <div class="rr-left">
                  <div class="rr-score">
                    <span class="rr-score-number">{{ $store.state.rating }}</span>
                    <span class="rr-score-star">★</span>
                  </div>
                  <div class="rr-meta">{{ $store.state.ratingsDisplay }}</div>
                </div>

                <!-- RIGHT SIDE -->
                <div class="rr-right">
                  <div
                    v-for="row in $store.state.ratingRows"
                    :key="row.stars"
                    class="rr-row"
                  >
                    <span class="rr-row-star">{{ row.stars }} ★</span>
                    <div class="rr-bar">
                      <div class="rr-bar-bg">
                        <div
                          class="rr-bar-fill"
                          :style="{ width: row.percent + '%' }"
                          :class="'stars-' + row.stars"
                        ></div>
                      </div>
                    </div>
                    <span class="rr-row-count">{{ row.count }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
        <div class="Setcard_row dashboardboxset">
          <div class="boxcommon rr-card" style="padding: 0px; background: none">
            <div class="rr-title">Selected Time</div>
          </div>
          <div class="dashboardboxset_left">
            <div class="boxc1 boxcommon">
              <div class="topsetheadeTcktrxs">
                <label class="d-flex">
                  <span> Total Tickets </span>
                  <b
                    ><span class="badge">{{
                      $store.state.dashboardAdminfullTotal
                    }}</span></b
                  >
                </label>
              </div>
            </div>
          </div>
          <div class="dashboardboxset_right">
            <div class="boxcommon">
              <div class="topsetheadeTcktrxs">
                <label class="d-flex">
                  <span> Total Customers </span>
                  <b
                    ><span class="badge">{{
                      $store.state.dashboardAdmincustomerTotal
                    }}</span></b
                  >
                </label>
              </div>
            </div>
            <div
              class="boxcommon"
              v-for="item in $store.state.dashboardAdminList"
              :key="item._id"
              :class="'subTicket-' + item._id"
            >
              <div class="topsetheadeTcktrxs">
                <label class="d-flex">
                  <span> {{ item.label }} Tickets </span>
                  <b
                    ><span class="badge">{{ item.totalTickets }}</span></b
                  >
                </label>
              </div>
            </div>
          </div>
        </div>
        <br />
        <div class="Setcard_row dashboardboxset">
          <div class="boxcommon rr-card" style="padding: 0px; background: none">
            <div class="rr-title">All Time</div>
          </div>
          <div class="dashboardboxset_left">
            <div class="boxc1 boxcommon">
              <div class="topsetheadeTcktrxs">
                <label class="d-flex">
                  <span> Total Tickets </span>
                  <b
                    ><span class="badge">{{
                      $store.state.dashboardAdminAllfullTotal
                    }}</span></b
                  >
                </label>
              </div>
            </div>
          </div>
          <div class="dashboardboxset_right">
            <div class="boxcommon">
              <div class="topsetheadeTcktrxs">
                <label class="d-flex">
                  <span> Total Customers </span>
                  <b
                    ><span class="badge">{{
                      $store.state.dashboardAdmincustomerAllTotal
                    }}</span></b
                  >
                </label>
              </div>
            </div>
            <div
              class="boxcommon"
              v-for="item in $store.state.dashboardAdminAllList"
              :key="item._id"
              :class="'subTicket-' + item._id"
            >
              <div class="topsetheadeTcktrxs">
                <label class="d-flex">
                  <span> {{ item.label }} Tickets </span>
                  <b
                    ><span class="badge">{{ item.totalTickets }}</span></b
                  >
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DatePicker from "vue-datepicker-next";
import "vue-datepicker-next/index.css";
import $ from "jquery";
import moment from "moment";
import axios from "axios";
import { ref } from "vue";

export default {
  name: "DashboardPage",
  components: {
    DatePicker,
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      tableLoader: 1,
      rating: 3.5,
      locale: "en",
      format: "MM-DD-YYYY",
      sameDateFormat: {
        from: "MM-DD-YYYY",
        to: "MM-DD-YYYY",
      },
      dateRange: [],
      value1: [
        new Date(this.$store.state.ticketListStartDate),
        new Date(this.$store.state.ticketListEndDate),
      ],
      averageTotalRatingDisplay: "4.0",
      totalRatingsDisplay: "7,021 Ratings",
      totalRatingRows: [],
      averageRatingDisplay: "4.0",
      ratingsDisplay: "7,021 Ratings",
      ratingRows: [],
    };
  },
  computed: {
    startDate() {
      return this.dateRange?.[0]
        ? moment(this.dateRange[0]).format("YYYY-MM-DD")
        : this.$store.state.ticketListStartDate;
    },
    endDate() {
      return this.dateRange?.[1]
        ? moment(this.dateRange[1]).format("YYYY-MM-DD")
        : this.$store.state.ticketListEndDate;
    },
  },
  watch: {
    startDate(newVal) {
      this.$store.state.ticketListStartDate = newVal;
    },
    endDate(newVal) {
      this.$store.state.ticketListEndDate = newVal;
    },
  },
  async mounted() {
    this.$store.state.pageTitle = "Dashboard";
    let token = localStorage.getItem("supportSystemAdmin");
    if (!token) {
      this.$store.state.user.accessToken = "";
      this.$router.push({ path: "/login" });
    } else {
      this.$router.push({ path: "/" });
    }
    if (this.windowWidth < 991) {
      $(".mainbody_cssclass").removeClass("sideMenuActive");
    }
    this.$store.state.isAdmin = 2;
    if (this.$store.state.adminLogin == 2) {
      this.$router.push({ path: "/" });
    }
    this.loadCountData();
    this.loadAllCountData();
    this.onResize();
            this.$nextTick(() => {
                window.addEventListener('resize', this.onResize);
            })
  },
  methods: {
    onResize() {
                this.windowWidth = window.innerWidth
                this.windowHeight = window.innerHeight

                var headNavCls = $('.headNavCls').outerHeight() || 0;
                var tsk_controls_main_cls = $('.tsk_controls_main_cls').outerHeight() || 0;
                var thead = $('thead').outerHeight() || 0;
                var databottom = $('.databottom').outerHeight() || 0;

                var cntSubvar = headNavCls + tsk_controls_main_cls + thead + databottom
                var tabHei = headNavCls + tsk_controls_main_cls + databottom
                var cntSubvar1 = this.windowHeight - cntSubvar
                tabHei = this.windowHeight - tabHei
                this.taskMainListHeight = tabHei;
                this.$store.state.tbody = cntSubvar1
                $('tbody').height(this.$store.state.tbody);
                if(this.isResonsiveCls == 2){
                    tabHei = tabHei-20
                }
                this.$store.state.pageTblHeightCls = tabHei
                $('.pageTblHeightCls').height(this.$store.state.pageTblHeightCls);
                this.checkHeightScroll();
            },
            checkHeightScroll() {
                $('.table').removeClass('ScrollAddedCls');
                if (this.hasScrollBar() == true) {
                    $('.table').addClass('ScrollAddedCls');
                }
            },
            hasScrollBar() {
                if ($(".tbodyCls")[0]) {
                    return $('.tbodyCls').get(0).scrollHeight > $('.tbodyCls').height() + 10;
                } else {
                    return false;
                }
            },
    startLoader() {
      this.$Progress.start();
    },
    finishLoader() {
      this.$Progress.finish();
    },
    dateFm(date) {
      let today = new Date(date);
      let day = String(today.getDate()).padStart(2, "0");
      let month = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      let year = today.getFullYear();
      return `${year}-${month}-${day}`;
    },
    async loadCountData() {
      this.tableLoader = 1;
      let token = localStorage.getItem("supportSystemAdmin");
      if (!token) {
        this.$store.state.user.accessToken = "";
      }
      this.startLoader();
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + this.$store.state.user.accessToken;
      await axios
        .get(process.env.VUE_APP_API_URL + "dashboard/get-counts", {
          params: {
            startDate: this.startDate,
            endDate: this.endDate,
          },
        })
        .then((resp) => {
          if (resp.status == 200 && resp.data.status == "success") {
            this.$store.state.dashboardAdminList = resp.data.data.labels;
            this.$store.state.dashboardAdminfullTotal = resp.data.data.fullTotal;
            this.$store.state.dashboardAdmincustomerTotal = resp.data.data.customerTotal;
            this.$store.state.allTimeRating = resp.data.data.allTimeRating;
            this.$store.state.totalRatingsDisplay = resp.data.data.totalRatingsDisplay;
            this.$store.state.totalRatingRows = resp.data.data.totalRatingRows;
            this.$store.state.rating = resp.data.data.rating;
            this.$store.state.ratingsDisplay = resp.data.data.ratingsDisplay;
            this.$store.state.ratingRows = resp.data.data.ratingRows;
          } else {
            this.$store.state.user.accessToken = "";
            this.$store.state.isActiveToken = "";
            this.$store.state.user.userInfo = "";
            this.$store.state.isAdmin = 2;
            localStorage.removeItem("supportSystemAdmin");
            this.$router.push({
              path: "/login",
            });
          }
          this.finishLoader();
        })
        .catch((error) => {
          console.error("There was an error!", error);
          console.log("response", error.response.status);
          console.log("message", error.response.data.message);
          // this.errorRes = error.response.data.message;
        });
    },
    async loadAllCountData() {
      this.tableLoader = 1;
      let token = localStorage.getItem("supportSystemAdmin");
      if (!token) {
        this.$store.state.user.accessToken = "";
      }
      this.startLoader();
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + this.$store.state.user.accessToken;
      await axios
        .get(process.env.VUE_APP_API_URL + "dashboard/get-counts", {
          params: {},
        })
        .then((resp) => {
          if (resp.status == 200 && resp.data.status == "success") {
            this.$store.state.dashboardAdminAllList = resp.data.data.labels;
            this.$store.state.dashboardAdminAllfullTotal = resp.data.data.fullTotal;
            this.$store.state.dashboardAdmincustomerAllTotal =
              resp.data.data.customerTotal;
          } else {
            this.$store.state.user.accessToken = "";
            this.$store.state.isActiveToken = "";
            this.$store.state.user.userInfo = "";
            this.$store.state.isAdmin = 2;
            localStorage.removeItem("supportSystemAdmin");
            this.$router.push({
              path: "/login",
            });
          }
          this.finishLoader();
        })
        .catch((error) => {
          console.error("There was an error!", error);
          console.log("response", error.response.status);
          console.log("message", error.response.data.message);
          // this.errorRes = error.response.data.message;
        });
    },
    onDateChange(newDates) {
      this.dateRange = newDates; // Update the selected range

      this.loadCountData();
    },
  },
  setup() {
    const selectedDate = ref(null);
    // const rating = ref(3.5);
    // Function to disable future dates
    const disableFutureDates = (date) => {
      return date.getTime() > new Date().getTime(); // Disable dates beyond today
    };

    return { selectedDate, disableFutureDates };
  },
};
</script>

<style scoped>
.rating-wrapper {
  user-select: none;
}
.star {
  font-size: 45px;
  color: #c44242;
  margin: 0 4px;
  transition: color 0.15s ease, transform 0.1s ease;
  display: inline-block;
}
/* Selected stars: rely only on the active class set by Vue */
.star.preview {
  color: #f7b700;
}

/* Hover preview color handled via class binding; keep base styles simple */

.star {
  font-size: 2rem;
  color: #bc93934a; /* default empty = black */
  position: relative;
}

.boxcommon .topsetheadeTcktrxs span.star.full {
  color: #f7b700 !important; /* default empty = black */
}
.boxcommon .topsetheadeTcktrxs span.star {
  color: #bc93934a !important;
}

.rr-card {
  padding: 15px;
  background: #e6f5fb; /* light card background */
  border-radius: 10px;
  height: auto;
  width: 100%;
}

.rr-title {
  font-weight: 600;
  font-size: 1rem;
  margin-bottom: 10px;
  color: #333;
}

.rr-container {
  display: flex;
  gap: 1.5rem;
  align-items: center;
}

.rr-left {
  text-align: center;
  min-width: 90px;
}

.rr-score {
  font-size: 2rem;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #000;
}

.rr-score-star {
  margin-left: 5px;
  font-size: 1.5rem;
  color: black;
}

.rr-meta {
  font-size: 0.85rem;
  color: #666;
}

.rr-right {
  flex: 1;
}

.rr-row {
  display: flex;
  align-items: center;
  margin: 4px 0;
}

.rr-row-star {
  width: 35px;
  font-size: 0.9rem;
  font-weight: 600;
}

.rr-bar {
  flex: 1;
  margin: 0 8px;
}

.rr-bar-bg {
  background: #eee;
  height: 8px;
  border-radius: 4px;
  overflow: hidden;
}

.rr-bar-fill {
  height: 100%;
  border-radius: 4px;
}

.stars-5 {
  background: #4caf50;
} /* Green */
.stars-4 {
  background: #81c784;
}
.stars-3 {
  background: #cddc39;
}
.stars-2 {
  background: #ff9800;
}
.stars-1 {
  background: #f44336;
}

.rr-row-count {
  width: 50px;
  text-align: right;
  font-size: 0.85rem;
  color: #333;
}
.ratingLeftMianCls {
  width: 49%;
  margin: 0;
  padding: 0;
}
@media (max-width: 992px) {
  .pageTblHeightCls {
    height: calc(100vh - 102px) !important;
  }
  .ratingLeftMianCls {
    width: 100%;
    padding: 3px;
  }
  .rr-card {
    height: 180px !important;
  }
}
</style>
